<ng-container *transloco="let t">
  <section
    class="best-sellers-picker-component"
    [class.widescreen]="(biggerThan$ | async)?.mobileL"
    [class.largescreen]="(biggerThan$ | async)?.sm">
    <div class="flex justify-between full-width align-base">
      <h3>{{ t('title_best_deals') }}</h3>
    </div>

    <span class="fixed-space-8" aria-hidden="true"></span>

    <div class="cards" [class.single-row]="hideImageBanner">
      @if (!hideImageBanner) {
        <div class="card position-relative">
          <img class="image-banner popsy-card p-0" [src]="bannerLink()" />
          <div class="banner-head">
            <h2 class="head" [innerHTML]="t('label_save_up_to')"></h2>
            <div class="timer flex align-base gap-8 ltr">
              <h1 id="hours">
                {{ countDownTimer().hoursToDday.toString().padStart(2, '0') }}
              </h1>
              <h1>:</h1>
              <h1 id="minutes">
                {{ countDownTimer().minutesToDday.toString().padStart(2, '0') }}
              </h1>
              <h1>:</h1>
              <h1 id="seconds">
                {{ countDownTimer().secondsToDday.toString().padStart(2, '0') }}
              </h1>
            </div>
            <div
              class="bottom bold"
              [routerLink]="informationPageUrlFragment('best-deals')"
              [queryParams]="queryParamsToKeep$ | async">
              {{ t('featured_banner_action') }}
            </div>
          </div>
        </div>
      }

      <div class="card products flex flex-col">
        <nav class="filters">
          @for (category of productCategories(); track trackByKey) {
            <span
              class="badge"
              [class.selected]="filteredCategory() === category"
              (click)="switchCategory(category)">
              {{ t('label_popular') }}
              {{
                t(
                  'category_' +
                    (capitalizeCategory(category)?.toLowerCase() || '') +
                    '_title'
                )
              }}</span
            >
          }
        </nav>
        @if (filteredCategory() === null) {
          <app-popsy-scroller>
            @for (best of bestSellersApi(); track trackByKey) {
              <app-best-seller-card [product]="best" />
            }
          </app-popsy-scroller>
        } @else {
          <app-popsy-scroller>
            @for (best of bestSellersPerCategory(); track trackByKey) {
              <app-cheapest-seller-card [product]="best" />
            }
          </app-popsy-scroller>
        }
      </div>
    </div>
  </section>
</ng-container>
